import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function WordIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fill="#2684FF"
        fillRule="evenodd"
        //JIRA Word Icon:  d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1zm0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1zm0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1zm0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1z"
        d="M 3 0 h 18 a 3 3 0 0 1 3 3 v 18 a 3 3 0 0 1 -3 3 H 3 a 3 3 0 0 1 -3 -3 V 3 a 3 3 0 0 1 3 -3 z m 1.376 6.013 A 0.437 0.437 0 0 0 4 6.446 v 11.15 c 0 0.219 0.161 0.404 0.378 0.434 l 11.125 1.538 a 0.437 0.437 0 0 0 0.497 -0.434 V 4.868 a 0.437 0.437 0 0 0 -0.499 -0.434 L 4.376 6.014 z M 17 7 v 10 h 2.5 a 0.5 0.5 0 0 0 0.5 -0.5 v -9 a 0.5 0.5 0 0 0 -0.5 -0.5 H 17 z M 7 15.5 l -1.5 -7 l 1.75 0 l 1 5 l 1 -5 h 1.5 l 1 5 l 1 -5 h 1.75 l -1.5 7 h -2.25 l -0.75 -3.75 l -0.75 3.75 z"
      />
    </SvgIcon>
  );
}
